<template>
    <div class="">
        <div class="relative min-h-screen min-w-screen">
            <default-header 
                type="light"
                :title="$t('registerforlifepass')"
                :text="$t('thankyouforchoosingdetails')"
                headerClasses="bg-primary shadow-2xl"
                textClasses="text-white"
                :masked="true"
            />
            <div class="px-6 pb-20"> 
                <form class="registerForm p-6 bg-white rounded-lg -mt-8 grid grid-cols-1 gap-6" @submit.prevent="processRegistration">
                    <fieldset class="grid grid-cols-1 gap-1">
                        <label for="firstname" class="text-sm">{{ $t('firstname') }}</label>
                        <input id="firstname" type="text" v-model="form.first_name" class="p-3 rounded border border-gray-200 placeholder-gray-300 text-primary focus:outline-none text-base" :placeholder="$t('enteryourfirstname')">
                    </fieldset>
                    <fieldset class="grid grid-cols-1 gap-1">
                        <label for="lastname" class="text-sm">{{ $t('lastname') }}</label>
                        <input id="lastname" type="text" v-model="form.last_name" class="p-3 rounded border border-gray-200 placeholder-gray-300 text-primary focus:outline-none text-base" :placeholder="$t('enteryourlastname')">
                    </fieldset>
                    <fieldset class="grid grid-cols-1 gap-1 phoneNumberInput">
                        <label for="mobileNumber" class="text-sm">{{ $t('mobilephonenumber') }}</label>
                        <vue-tel-input :value="form.mobile" @input="onInput" v-bind="vueTel.props" class="rounded border border-gray-200 placeholder-gray-300 text-primary focus:outline-none text-base relative"></vue-tel-input>
                    </fieldset>
                    <div class="flex items-center space-x-3">
                      <div class="flex items-center">
                          <label class="checkboxRounded cursor-pointer flex items-center">
                              <input type="checkbox" name="" class="checkboxRounded__input block" v-model="acceptedMobileConfirm">
                              <span class="checkboxRounded__inner mr-2"></span>
                              <span class="block text-md"></span>
                          </label>
                      </div>
                      <p class="text-xs text-primary opacity-40">{{ $t('verifiedmobile') }}</p>
                    </div>
                    <a href="https://lifepass.eu/privacy" target="_blank" class="text-xs text-primary opacity-40 text-center pt-4">{{ $t('findouthowweuseyourdetails') }}</a>
                    <div class="flex fixed left-0 bottom-6 w-full flex-col items-center justify-center space-y-4 px-6 mt-6 bg-white">
                        <default-button
                          buttonClasses=""
                          :disabled="!acceptedMobileConfirm"
                          :text="$t('register')"
                        />
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import DefaultButton from "@/components/Button.vue";
import DefaultHeader from "@/components/Header.vue";

export default {
  components: {
    VueTelInput,
    DefaultHeader,
    DefaultButton
  },
  data() {
    return {
      termsPdf: require('@/assets/tcs/LifePassEULA.pdf'),
      form: {
        first_name: null,
        last_name: null,
        mobile: null
      },
      acceptedMobileConfirm: false,
      logo: null,
      card: null,
      vueTel: {
        props: {
          preferredCountries: ["GB", "FR", "IT", "DE"],
          defaultCountry: this.getCurrentSelectedLang(),
          mode: "international",
          disabledFormatting: true,
          wrapperClasses: "country-phone-input",
          inputOptions: {
            placeholder: this.$t('enterphonenumber')
          }
        }
      }
    };
  },
  mounted() {
    if(!this.$route.query.c) {
      this.card = window.localStorage.getItem('card', this.$route.query.c);
    }else {
      this.card = this.$route.query.c;
    }
    
    if (window.localStorage.getItem('token')) {
      this.axios
        .get(`${process.env.VUE_APP_API_BASE_URL}/api/devices`)
        .then(() => {
          this.$router.push({ name: 'Dashboard' });
        }).catch(() => {
          
        })
    }
    var usersName = window.localStorage.getItem('usersName');
    var usersMobile = window.localStorage.getItem('usersMobile');

    this.form.first_name = usersName.substring(0, usersName.indexOf(' '));
    this.form.last_name = usersName.substring(usersName.indexOf(' ') + 1);
    this.form.mobile = usersMobile;

    this.ac = this.$route.query.ac;
    this.oid = this.$route.query.oid;
  },
  methods: {
    onInput(phone, phoneObject) {
      if (phoneObject) {
          this.form.mobile = phoneObject.number;
      }
    },
    processRegistration() {
      const formData = {
          firstName: this.form.first_name,
          lastName: this.form.last_name,
          countryCode: 'GB',
          mobile: this.form.mobile.replace("+", ""),
          email: 'apporders@lifepass.eu',
          language: window.localStorage.getItem('selectedLangShort'),
      }

      this.axios
        .post(`${process.env.VUE_APP_API_BASE_URL}/api/app/booking?ac=${this.ac}&oid=${this.oid}`, formData)
        .then(() => {
          this.$router.push({ name: 'registerThanks', query: this.$route.query})
        }).catch(() => { 
          alert('CORS error, failed to register.');
        })
    },
    getCurrentSelectedLang() {
      let lang = window.localStorage.getItem('selectedLangShort');
      if(lang == 'en') {
        lang = 'GB'
        return lang;
      }
      return lang.toUpperCase();
    }
  }
};
</script>

<style lang="scss">
  .vti__dropdown {
    position: initial;
    border-right: 1px solid rgba(228, 228, 231, 1);
    margin-right: 0.25rem;
    padding: 1rem;
    &:focus {
      outline: none;
    }
  }
  .vti__dropdown-list {
    max-width: 100%;
    border-radius: 6px;
    padding: 1.5rem;
    border: 1px solid rgba(228, 228, 231, 1);
    .vti__dropdown-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px solid rgba(228, 228, 231, 1);
      padding: 0 0 1.1rem 0;
      margin: 0 0 1.1rem 0;
    }
  }
  .vti__dropdown-item .vti__flag {
    margin-right: 10px;
  }
  .phoneNumberInput {
    ::-webkit-input-placeholder {
      color: rgba(212, 212, 216, 1)!important;  
    }
  }
</style>